import React, { Component } from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <div>
      <footer
        className="page-footer font-small blue pt-4 mt-5"
        style={{ paddingTop: "3rem" }}
      >
        {/* Footer Links */}
        <div className="container text-start text-md-left">
          {/* Grid row */}
          <div className="row">
            {/* Grid column */}
            <div className="col-md-6 mt-md-0 mt-3">
              {/* Content */}
              <h5 className="text-uppercase">Development Summary</h5>
              <p className="text-justify">
             Me as a <strong>Front-end Developer</strong> have the capacity<br />  to bringyour vision to life, whether or not you <br /> have programming expertise.
              </p>
            </div>
            {/* Grid column */}
            <hr className="clearfix w-100 d-md-none pb-3" />
            {/* Grid column */}
            <div className="col-md-6 ">
              {/* Links */}
              <h5 className="text-uppercase">Skills</h5>
              <ul className="list-unstyled">
                <li>
                  <a href="#!"></a>
                </li>
                {/* <li>
                  React js Development
                </li> */}
               
                <li>
                  Bootstrap Development
                </li>
                <li>
                  JavaScript Development
              </li>
              <li>
                  JQuery Development
              </li>
                  <li>
                  React js Development
                </li>
              
                <li>
                  UI/UX
                </li>
                <li>
                  Quality Assurance
                </li>
                <li>
                  Search Engine Optimization
                </li>
              </ul>
            </div>
            {/* Grid column */}
            {/* Grid column */}
       
            {/* Grid column */}
          </div>
          {/* Grid row */}
        </div>
        {/* Footer Links */}
        {/* Copyright */}
        <div className="footer-copyright text-start py-3 container text-center text-md-left">
        </div>
        {/* Copyright */}
      </footer>
    </div>
  );
};

export default Footer;
